import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import logo from './logo.svg';
import './App.css';
const d3 = require('d3');
const corslite = require('corslite');
const _ = require('underscore');
const MapboxGeocoder = require('mapbox-gl-geocoder');

const codes = {
  '10': 'DSL',
  '11': 'DSL',
  '12': 'DSL',
  '20': 'DSL',
  '30': 'Copper',
  '40': 'Cable',
  '41': 'Cable',
  '42': 'Cable',
  '43': 'Cable',
  '50': 'Fiber',
  '70': 'Other',
  '90': 'Other',
  '0': 'Other'
};

mapboxgl.accessToken = 'pk.eyJ1IjoiY2FzZXltbWlsbGVyIiwiYSI6ImNqOTA5MnM4ZjFmczQzMm5yeDh6dGl4bzYifQ.8UpLp0pRK-061KtJsIYViQ';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      'providers': [],
      'coords': null
    }
    this.updateMap = this.updateMap.bind(this);
  }
  map;

  updateMap(){
    // console.log(this.state)
    this.forceUpdate();
  }

  componentDidMount() {


    var svg = d3.select("svg"),
       width = +svg.attr("width"),
       height = +svg.attr("height");

    var x = d3.scaleLinear()
      .domain([0, 1, 2, 3, 4, 5])
      .rangeRound([0, 40]);

    var color = d3.scaleLinear()
              .domain([0, 5])
              .range(["#fff", "#590099"]);

    var g = svg.append("g")
       .attr("class", "key")
       .attr("transform", "translate(10,30)");

    g.selectAll("rect")
     .data([1, 2, 3, 4, 5])
     .enter().append("rect")
       .attr("height", 18)
       .attr("x", function(d) {
         return d*40; })
       .attr("width", function(d) { return 40; })
       .attr("fill", function(d) { return color(d); });

    g.append("text")
       .attr("class", "caption")
       .attr("x", 0)
       .attr("y", -8)
       .attr("fill", "#000")
       .attr("text-anchor", "start")
       .text("Consumer providers");

    g.call(d3.axisBottom(x)
       .tickSize(18)
       .tickFormat(function(d){
         if(d === 5){
           return '5+';
         } else {
           return d;
         }
       })
       .tickValues(x.domain()))
     .select(".domain")
       .remove();

    g.append('line')
     .attr('y1', 1)
     .attr('y2', 1)
     .attr('x2', 40)

   g.append('line')
    .attr('y1', 17)
    .attr('y2', 17)
    .attr('x2', 40)

    d3.select('.key').insert('rect', ':first-child')
      .attr('x', 0)
      .attr('height', 18)
      .attr('width', 40)
      .attr('fill', '#fff');

    d3.selectAll(".tick text")
      .attr('x', 20)
      .attr('y', 25);

    let thing = this;

    const renderMap = (coords) => {
      thing.map = new mapboxgl.Map({
        container: this.mapContainer,
        style: 'mapbox://styles/caseymmiller/cjb3wiqrz5aw32sng8gpzcpxi/',
        center: coords,
        maxZoom: 17,
        minZoom: 14,
        zoom: 15
      });

      const geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken, zoom: 15, country: 'US', 'flyTo': false });

      const getAddress = (data) => {
        geocoder.setInput(data.features[0].place_name);
      };

      thing.map.on('load', () => {
        thing.setState({coords: coords});

        thing.map.addControl(geocoder);

        if(coords === [-73.990538, 40.727592]){
          geocoder.setInput('Scratcher, 209 E 5th St, New York, New York 10003, United States');
        } else {
          const geoStr = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'+coords[0]+','+coords[1]+'.json?access_token='+mapboxgl.accessToken;
          d3.json(geoStr)
            .get(getAddress);
        }

        geocoder.on('result', (res) => {
          const coords = res.result.center;
          thing.map.setCenter(coords);
          d3.select('#legend').html('');
          this.setState({coords: coords});
        });


        thing.map.on('click', function (e) {
            var features = thing.map.queryRenderedFeatures(e.point);
            // console.log(features);
            // console.log(e.lngLat);
            thing.map.flyTo({
              center: [
                  e.lngLat.lng,
                  e.lngLat.lat]
            });
            const geoStr = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'+e.lngLat.lng+','+e.lngLat.lat+'.json?access_token='+mapboxgl.accessToken;
            d3.json(geoStr)
              .get(getAddress);

            thing.setState({coords: [e.lngLat.lng, e.lngLat.lat]});
        });
      });
    }

    navigator.geolocation.getCurrentPosition(function(position) {
      // fix this for the phone
      const oldCoords = position.coords;
      const coords = [
          oldCoords.longitude,
          oldCoords.latitude];
      renderMap(coords);
    }, function (error){
      const coords = [-73.990538, 40.727592];
      renderMap(coords);
    });

    if(window.innerHeight < 330){
      console.log('yes less than 330')
      d3.selectAll('.absolute.top.right.left.bottom').classed('extra', true);
    }

  }

  render() {
    d3.select('#legend').html('<div class="loading-placeholder"><div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div>\
    <div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube">\
    </div></div><div class="load-icon">loading</div></div>');
    const thisMap = this;
    const tempProviders = {};

    const getFccData = (data) => {
      const resp = JSON.parse(data.response);
      resp.forEach(item => {
        if(item.techcode !== '60' && item.consumer === '1'){
          if(!_.has(tempProviders, item['hoconum'])){
            tempProviders[item['hoconum']] = [item];
          } else {
            tempProviders[item['hoconum']].push(item);
          }
        }
      })
      // console.log(tempProviders, Object.keys(tempProviders).length);
      d3.select('#legend').html('');
      d3.select('#legend').append('div').attr('class', 'header')
        .html(Object.keys(tempProviders).length+' consumer providers');
      const providersA = [];
      Object.keys(tempProviders).forEach(item => {
        const temp = {};
        const services = [];
        temp['name'] = tempProviders[item][0]['dbaname'];
        tempProviders[item].forEach(provider => {
          if(!(services.indexOf(codes[provider.techcode]) > -1)){
            services.push(codes[provider.techcode])
          }
        });
        temp['services'] = services.sort();
        providersA.push(temp);
      });

      const providers = _.sortBy(providersA, 'name');

      providers.forEach(provider => {
        const pItem = d3.select('#legend').append('div');
        pItem.append('span').html(provider.name+' ');
        const servs = pItem.append('span');
        provider.services.forEach(service => {
          servs.append('span').attr('class', 'bg-purple-dark color-purple-faint inline-block px6 py3 txt-xs txt-bold round-full').html(service);
        })
      })
    }

    const getCensusBlock = (data) => {
      const block = JSON.parse(data.response)['Block']['FIPS'];
      d3.request('https://opendata.fcc.gov/resource/if4k-kzsc.json?blockcode='+block)
        .get(getFccData);
    }

    if(this.state.coords){
      d3.request('https://cors-mbx.herokuapp.com/https://data.fcc.gov/api/block/find?format=json&latitude='+this.state.coords[1]+'&longitude='+this.state.coords[0]+'&showall=true')
        .get(getCensusBlock);

      if(this.map.getSource('loc_point')){
        const temp = {
          "type": "Point",
          "coordinates": this.state.coords
        }
        this.map.getSource('loc_point').setData(temp);
      } else {
        this.map.addSource('loc_point', {
            type: 'geojson',
            data: {
                "type": "Point",
                "coordinates": this.state.coords
            }
        });
        this.map.addLayer({
            "id": 'loc_point_layer',
            "type": "circle",
            "source": 'loc_point',
            "paint": {
              'circle-radius': 6,
              'circle-color': '#00c7ff',
              "circle-stroke-color": "#fff",
              "circle-stroke-width": {
                  'base': .3,
                  'stops': [[2, .5], [10, 2]]
              }
            }
        });
      }
    }

    return (
      <div>
        <div ref={el => this.mapContainer = el} className="absolute top right left bottom" />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js